import { Component, HostBinding, OnDestroy, OnInit, signal } from '@angular/core';
import { collapseAnimations } from "../../animations/collapse.animations";
import { Network } from "@capacitor/network";
import { PluginListenerHandle } from "@capacitor/core";

@Component({
  selector: 'pkp-online-indicator',
  templateUrl: './online-indicator.component.html',
  styleUrls: ['./online-indicator.component.scss'],
  standalone: true,
  animations: [collapseAnimations]
})
export class OnlineIndicatorComponent implements OnInit, OnDestroy {
  readonly online = signal(true);
  #listenerHandle?: PluginListenerHandle;

  @HostBinding('style.backgroundColor') get bgColor() {
    return this.online() ? 'green' : 'red';
  }

  async ngOnInit() {
    const status = await Network.getStatus();
    this.online.set(status.connected);

    this.#listenerHandle = await Network.addListener('networkStatusChange', (state) => {
      this.online.set(state.connected);
    });
  }

  ngOnDestroy() {
    this.#listenerHandle?.remove();
  }
}
